var React = require('react');

function Attachment (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11 14.5c0 3-2.5 5.5-5.5 5.5S0 17.5 0 14.5V4c0-2.2 1.8-4 4-4s4 1.8 4 4v8.5C8 13.9 6.9 15 5.5 15S3 13.9 3 12.5V5h1.5v7.5c0 .6.4 1 1 1s1-.4 1-1V4c0-1.4-1.1-2.5-2.5-2.5S1.5 2.6 1.5 4v10.5c0 2.2 1.8 4 4 4s4-1.8 4-4V5H11v9.5z","fill":"currentColor","fillRule":"evenodd","fillOpacity":".6"}));
}

Attachment.defaultProps = {"viewBox":"0 0 11 20","width":"11","height":"20"};

module.exports = Attachment;

Attachment.default = Attachment;
